import { render, staticRenderFns } from "./materialNew.vue?vue&type=template&id=42092268&scoped=true"
import script from "./materialNew.vue?vue&type=script&lang=js"
export * from "./materialNew.vue?vue&type=script&lang=js"
import style0 from "./materialNew.vue?vue&type=style&index=0&id=42092268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42092268",
  null
  
)

export default component.exports